<template>
  <div>
    <template v-if="!invoiceExists">
      <p class="mt-3 mb-4 text-center text-muted" v-if="!invoiceExists">No Invoice History</p>
    </template>
    <template v-else>
      <div class="invoice-shortlist">
        <div class="invoice-item d-flex justify-content-between" v-for="item in invoiceShortList.items">
          <span class="text-info">Invoice {{item.number_formatted}}</span>
          <span>${{item.total_amount}}</span>
        </div>
        <div class="text-center mt-3 mb-2" v-if="invoiceShortList.seeMore">
          <b-link class="text-info" @click="seeAllInvoices">See All Invoices</b-link>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      shortListCount: 3,
    }
  },
  computed: {
    ...mapGetters([
      'error',
      'loading',
      'user',
      'stripeInvoicesLoading',
      'stripeInvoicesHasMore',
      'stripeInvoices',
    ]),
    invoiceExists: function() {
      return this.stripeInvoices.length > 0
    },
    invoiceShortList: function() {
      return {
        items: this.stripeInvoices.slice(0, this.shortListCount).map((i) => ({
          ...i,
          total_amount: ((i.amount_paid + i.amount_remaining) / 100).toFixed(2),
          number_formatted: i.number.split('-')[1]
        })),
        seeMore: this.stripeInvoicesHasMore || this.stripeInvoices.length > this.shortListCount
      }
    }
  },
  methods: {
    seeAllInvoices() {
      this.$emit('seeAllInvoices')
    }
  }
}
</script>
<style lang="scss">
  .invoice-shortlist {
    .invoice-item {
      line-height: 3;
      border-bottom: solid 1px #eee;
    }
  }
</style>
